<template>
    <div>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ชื่อวัสดุ</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="factorial.name"
                       disabled
                />
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>แหล่งที่มา</label>
            </b-col>
            <b-col sm="6">
                <select class="form-control mr-sm-2 w-100" disabled
                        v-model="factorial.source_id">
                    <option value="1">ในประเทศ</option>
                    <option value="2">นอกประเทศ</option>
                </select>
            </b-col>
        </b-row>
        <br>

        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>ชื่อผู้เบิก</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="text"
                       v-model="form.technical"
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>จำนวนเบิก</label>
            </b-col>
            <b-col sm="6">
                <input class="form-control"
                       type="number"
                       v-model="form.quantity"
                />
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>วันที่นำออก</label>
            </b-col>
            <b-col sm="6">
                <date-picker
                    v-model="form.date"
                    :format="changeFormat"
                    class="w-100"
                    :lang="lang"
                    confirm
                    placeholder="วันที่เบิก"></date-picker>
            </b-col>
        </b-row>
        <br>
        <b-row sm="10">
            <b-col sm="4" class="col text-right">
                <label>หมายเหตุ</label>
            </b-col>
            <b-col sm="6">
                <textarea v-model="form.remark" class="form-control"></textarea>
            </b-col>
        </b-row>
        <input type="hidden" />
        <br>
        <b-row>
            <div class="col text-center">
                <button @click="onSubmitExport"
                        :disabled="form.onSave"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึก
                </button>&nbsp;&nbsp;
                <button @click="cancelModal"
                        type="button"
                        class="btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
        </b-row>
        <br>
<!--        <pre class="alert-primary">{{factorial}}</pre>-->
<!--        <pre class="alert-primary">{{form}}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";

    export default {
        name: "factorial-material-export-modal",
        components: {
            DatePicker,
        },
        created(){
            this.$store.dispatch("FactorialMaterialExport/setFactorialMaterialExport");
            this.$store.dispatch("FactorialMaterialExport/clearFormData");
            this.$store.dispatch("FactorialMaterialExport/clearSearch");
        },
        data() {
            return {
                event_submit : false,
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        console.log(moment(date).format('DD/MM/'+year));
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            };
        },
        computed:{
            ...mapState({
                user: state => {
                    return state.Auth.user;
                },
                form: state => {
                    return state.FactorialMaterialExport.form;
                },
                factorial: state => {
                    return state.FactorialMaterial.form;
                },
            })
        },
        methods:{
            onSubmitExport() {
                if(!this.form.technical){
                    alert('กรุณาใส่ชื่อผู้เบิก')
                }
                else if(!this.form.quantity){
                    alert('กรุณาใส่จำนวน')
                }
                else if(this.form.quantity < 1){
                    alert('กรุณาใส่จำนวนให้ถูกต้อง')
                }
                else{
                    let data = {
                        id: this.form.id,
                        factorial_id: this.factorial.id,
                        user_id : this.user.id,
                        quantity : this.form.quantity,
                        source_id : this.factorial.source_id,
                        technical : this.form.technical,
                        remark : this.form.remark,
                        date : this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '',
                    };
                    this.form.onSave = true;
                    this.$emit("submit", data);
                }
            },
            cancelModal(){
                this.$emit("submit", 0);
                this.$store.dispatch("FactorialMaterialImport/clearFormData")
            },
        }
    }
</script>

<style scoped>

</style>
